export default [
    {
      path: '/mine/shippingAddress',
      name: 'shippingAddress',
      meta: {
        index: 12
      },
      component: () => import('@/views/mine/shippingAddress.vue')
    }
  ]


